import { beAccountDeliverabilityApiGetDeliverabilityIndex } from 'Api/beAccountDeliverabilityApi'
import {
  beAccountSettingsApiGetUser,
  beAccountSettingsApiSendContactRequest,
} from 'Api/beAccountSettingsApi'
import { STORE_KEY_ID_LIST, STORE_KEY_USER } from 'Constants'
import type { DeliverabilityList } from 'Types/beAccountDeliverabilityApi'
import type { User } from 'Types/beAccountSettingsApi'
import { storeGet } from 'mailup-react-helpers'

export const getDeliverabilityIndex =
  async (): Promise<DeliverabilityList | null> => {
    const idList: number = storeGet(STORE_KEY_ID_LIST)
    const res = await beAccountDeliverabilityApiGetDeliverabilityIndex({
      list: idList,
    })
    if (res !== null) {
      const { ScoreData, AlertsData } = res
      return ScoreData != null && AlertsData?.Audit ? res : null
    }
    return null
  }

export const getUserEmail = async (): Promise<string> => {
  const { Id: idUser } = storeGet(STORE_KEY_USER)
  const user = await beAccountSettingsApiGetUser(idUser)
  return user?.RecoverEmail || ''
}

interface ContactRequestData {
  tipType: string
  tipSubType: string
  email: string
  score: number
  text: string
}
export async function sendContactRequest(
  data: ContactRequestData,
): Promise<void> {
  const { tipType, tipSubType, email, score, text } = data
  const title = tipType + ' ' + tipSubType
  const description = `Email: ${email}\n Score: ${score}\n ${text}`
  await beAccountSettingsApiSendContactRequest({
    Title: title,
    Description: description,
  })
}
